import React from "react";

const MenuItemContent = ({
  icon,
  shortcut,
  badge,
  textStyle,
  children,
}: {
  icon?: React.ReactNode;
  shortcut?: string;
  badge?: React.ReactNode;
  textStyle?: React.CSSProperties;
  children: React.ReactNode;
}) => (
  <>
    {icon && <span className="dropdown-menu-item__icon">{icon}</span>}
    <span className="dropdown-menu-item__text" style={textStyle}>
      {children}
    </span>
    {badge && <span className="dropdown-menu-item__badge">{badge}</span>}
    {shortcut && (
      <span className="dropdown-menu-item__shortcut">{shortcut}</span>
    )}
  </>
);

export default MenuItemContent;
